import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Charts can be added to any slide using the built-in chart features in both Keynote and Google Slides.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do alt="Example of a chart with a white background on a slide with a white background" src="https://user-images.githubusercontent.com/10384315/54648916-487fd400-4a65-11e9-8e8f-ae4914910617.png" mdxType="Do">
    Use a white slide for charts with white backgrounds.
  </Do>
  <Dont alt="Example of a chart with a white background on a slide with a black background" src="https://user-images.githubusercontent.com/10384315/54649021-b88e5a00-4a65-11e9-9288-9d2a1c8e9428.png" mdxType="Dont">
    Add a chart with a white background to a black slide.
  </Dont>
    </DoDontContainer>
    <h3>{`Charts in Keynote`}</h3>
    <p>{`To add a chart in Keynote click the `}<img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/10384315/54716264-97377780-4b12-11e9-828f-f006a0679c50.png",
        "alt": "Chart button"
      }}></img>{` button in the top toolbar.`}</p>
    <p>{`To edit the data in the chart click the chart (if not already selected) and click the `}<strong parentName="p">{`Edit Chart Data`}</strong>{` button.
A small spreadsheet window will appear and you can copy/paste your data into the cells.`}</p>
    <h3>{`Charts in Google Slides`}</h3>
    <p>{`To add a chart in Google slides, click `}<strong parentName="p">{`Insert > Chart`}</strong>{` and select the type of chart you would like to use.`}</p>
    <p>{`If you already have your data in a specific Google Sheet, click `}<strong parentName="p">{`From Sheets...`}</strong></p>
    <p>{`To edit the data in the chart, select the chart and click the dropdown arrow in the top right corner. Select `}<strong parentName="p">{`Open Source`}</strong>{` and you will be moved to the Google Sheet containing the data for your chart. Within the Sheet, you can update values and customize the appearance of your chart. To view any of the changes made to your chart and/or its data, click `}<strong parentName="p">{`Update`}</strong>{` to refresh the chart.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      